/**
 * Values read from localStorage once at module load, shared by the slices that
 * seed their initial state from it.
 *
 * Only these keys are ever hydrated from the local cache; everything else the
 * store persists is write-only there and owned by the server (see persistence.ts).
 */
import { loadData } from './persistence';
import { OstState } from '../types';
import { getDefaultNodePanelPosition } from '../utils/ostUtils';

/** Default corner colour applied to a newly created insight card. */
export const DEFAULT_INSIGHT_CORNER_COLOR = '#f28c5c';

const savedData = loadData();

export const initialData: OstState = {
    outcome: savedData?.outcome ?? null,
    opportunities: savedData?.opportunities ?? [],
    solutions: savedData?.solutions ?? [],
    userStories: savedData?.userStories ?? [],
    positions: savedData?.positions ?? {},
    nodePanelPosition: savedData?.nodePanelPosition ?? getDefaultNodePanelPosition(),
    solutionChildType: savedData?.solutionChildType ?? 'story',
};
